import { Global } from '../../Global';
import { Environment } from '../../types/Environment';

export const getEnv = (): Environment =>
  Global.backend === 'legoasutv01'
    ? Environment.LocalUtveckling
    : (window.fsokConfig.environment as Environment);
